"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetApprovalsSite = void 0;
const React = require("react");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const switch_1 = require("client/components/material/switch");
const review_supporting_document_1 = require("../../components/review-supporting-document");
const router_1 = require("client/components/router");
const material_ui_1 = require("material-ui");
const store_1 = require("../../store");
const throttle_debounce_1 = require("throttle-debounce");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const store_2 = require("client/modules/users/store");
const moment = require("moment");
const core_1 = require("@material-ui/core");
const columns = [
    {
        id: "site.name",
        label: "Pharmacy"
    },
    {
        id: "sdum.groupName",
        label: "Group"
    },
    {
        id: "sdum.createdAt",
        label: "Request Date"
    },
    {
        id: "NO_ACTION",
        label: "Status"
    }
];
const styles = (theme) => core_1.createStyles({
    approved: {
        background: "rgba(30, 193, 114, 0.05)"
    },
    rejected: {
        background: "rgba(193, 30, 30, 0.05)"
    }
});
let AssetApprovalsSiteUnstyled = class AssetApprovalsSiteUnstyled extends React.Component {
    constructor() {
        super(...arguments);
        this.order = "ASC";
        this.orderBy = "site.name";
        this.isCollapse = true;
        this.editId = -1;
        this.autoFocusForm = true;
        this.currentRowIndex = -1;
        this.routeId = -1;
        this.showRejected = false;
        this.showApproved = false;
        this.loadData = throttle_debounce_1.debounce(200, async () => {
            const options = {
                count: 1000,
                order: this.order,
                showApproved: this.showApproved.toString(),
                showRejected: this.showRejected.toString(),
                sort: this.orderBy,
                start: 0
            };
            await store_1.assetApprovalsStore.listSupportingDocuments(options);
        });
        this.onHandleClickRow = (row, index) => {
            if (this.editId === row.id) {
                this.isCollapse = !this.isCollapse;
                this.autoFocusForm = true;
            }
            else {
                this.isCollapse = false;
            }
            this.editId = row.id;
            this.currentRowIndex = index;
            router_1.RouteManager.transitionTo(`/assetapprovals/site/${row.id}`);
        };
        this.onHandleSave = async (asset, decision, reason) => {
            await store_1.assetApprovalsStore.updateSiteChangeRequest(asset, decision, reason);
            await this.loadData();
            router_1.RouteManager.transitionTo("/assetapprovals/site/");
        };
        this.renderListRowEditMode = (row, index) => (React.createElement("div", { key: -1 }, !this.isCollapse && (this.editId === row.id || this.routeId === row.id) && (React.createElement(review_supporting_document_1.ReviewSupportingDocument, { autoFocusForm: this.autoFocusForm, error: store_1.assetApprovalsStore.supportingDocuments.error, key: index, loading: store_1.assetApprovalsStore.supportingDocuments.loading, onCancel: () => {
                this.editId = -1;
                router_1.RouteManager.transitionTo("/assetapprovals/site/");
            }, onSave: this.onHandleSave, asset: row, status: store_1.assetApprovalsStore.supportingDocuments.status }))));
        this.getStatus = (sdum) => sdum.approved ? "Approved" : sdum.rejected ? "Rejected" : "Pending";
        this.renderListRow = (row, index) => {
            const { classes } = this.props;
            const { site } = row;
            const status = this.getStatus(row);
            return [
                React.createElement(list_item_1.MaterialListItem, { className: status === "Approved"
                        ? classes.approved
                        : status === "Rejected"
                            ? classes.rejected
                            : "", key: index, onClick: () => {
                        this.onHandleClickRow(row, index);
                    } },
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: site.displayName }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: row.groupName }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: moment(row.createdAt).format("M-DD-YYYY") }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: status })),
                this.renderListRowEditMode(row, index)
            ];
        };
        this.onRequestSort = async (property) => {
            if (this.orderBy === property) {
                if (this.order === "ASC") {
                    this.order = "DESC";
                }
                else {
                    this.order = "ASC";
                }
            }
            else {
                this.orderBy = property;
                this.order = "ASC";
            }
            await this.loadData();
        };
        this.handleToggle = (type) => async () => {
            if (type === "showApproved") {
                this.showApproved = !this.showApproved;
            }
            else if (type === "showRejected") {
                this.showRejected = !this.showRejected;
            }
            await this.loadData();
        };
    }
    UNSAFE_componentWillMount() {
        if (this.props.params) {
            this.routeId = Number(this.props.params[0]);
        }
        if (this.routeId > 0) {
            this.isCollapse = false;
        }
    }
    async componentDidMount() {
        const options = {
            count: 1000,
            order: this.order,
            showApproved: this.showApproved.toString(),
            showRejected: this.showRejected.toString(),
            sort: this.orderBy,
            start: 0
        };
        await store_1.assetApprovalsStore.listSupportingDocuments(options);
    }
    componentDidUpdate() {
        // ReactTooltip.rebuild();
        if (this.props.params) {
            this.routeId = Number(this.props.params[0]);
        }
        if (this.routeId > 0 && this.editId !== this.routeId) {
            this.isCollapse = false;
            this.editId = this.routeId;
        }
        if (this.props.params && this.props.params.length === 0) {
            this.isCollapse = true;
            this.editId = -1;
        }
    }
    renderList() {
        const { supportingDocuments: { value = [] } } = store_1.assetApprovalsStore;
        return (React.createElement("div", { className: "asset-approvals__data__list__info" },
            React.createElement(list_1.MaterialList, { columns: columns, onRequestSort: this.onRequestSort, order: this.order, orderBy: this.orderBy, rows: value, renderRow: this.renderListRow, withMargin: true, wideHeader: true, resizableheader: true, customClass: "custom-material-list__supporting-document-asset" })));
    }
    renderInfo() {
        return (React.createElement("div", { className: "asset-approvals__data" },
            React.createElement(material_ui_1.Typography, { variant: "display1" }, "Pharmacy Info Update Request"),
            React.createElement("div", { className: "asset-approvals__data__toggle" },
                React.createElement(switch_1.MaterialSwitch, { label: "Show Approved", value: "showApproved", checked: this.showApproved, onChange: this.handleToggle("showApproved") }),
                React.createElement(switch_1.MaterialSwitch, { label: "Show Rejected", value: "showRejected", checked: this.showRejected, onChange: this.handleToggle("showRejected") })),
            React.createElement("div", { className: "asset-approvals__data__list" }, this.renderList())));
    }
    render() {
        return (React.createElement("div", { className: "asset-approvals" }, store_2.usersStore.permissions.ReadAssetApprovals ? (React.createElement(React.Fragment, null, this.renderInfo())) : (store_2.usersStore.showLock())));
    }
};
__decorate([
    mobx_1.observable
], AssetApprovalsSiteUnstyled.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], AssetApprovalsSiteUnstyled.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], AssetApprovalsSiteUnstyled.prototype, "isCollapse", void 0);
__decorate([
    mobx_1.observable
], AssetApprovalsSiteUnstyled.prototype, "editId", void 0);
__decorate([
    mobx_1.observable
], AssetApprovalsSiteUnstyled.prototype, "autoFocusForm", void 0);
__decorate([
    mobx_1.observable
], AssetApprovalsSiteUnstyled.prototype, "currentRowIndex", void 0);
__decorate([
    mobx_1.observable
], AssetApprovalsSiteUnstyled.prototype, "routeId", void 0);
__decorate([
    mobx_1.observable
], AssetApprovalsSiteUnstyled.prototype, "showRejected", void 0);
__decorate([
    mobx_1.observable
], AssetApprovalsSiteUnstyled.prototype, "showApproved", void 0);
AssetApprovalsSiteUnstyled = __decorate([
    mobx_react_1.observer
], AssetApprovalsSiteUnstyled);
exports.AssetApprovalsSite = core_1.withStyles(styles)(AssetApprovalsSiteUnstyled);



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/asset-approvals/tabs/asset-approvals-site/asset-approvals-site.tsx
// module id = 3262
// module chunks = 0